<template>
	<div class="interviewDialog">
		<el-dialog :visible.sync="dialogShow" width="419px" class="quan-dialog-out-class" :close-on-click-modal="true"
			@closed="closeDialog">
			<div class="dialog-member-title">
				<span class="dialog-member-name">面试信息</span>
				<div class="dialog-close" @click="closeDialog">
					<i class="el-icon-close"></i>
				</div>
			</div>
			<div class="quan-num-add">
				<el-form ref="ruleForm" label-width="100px" style="margin-top: 20px;">
					<el-form-item label="面试时间：" prop="interviewTime">
						<el-date-picker v-model="queryInfoData.time" type="datetime" placeholder="选择面试时间"
							value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						<!-- <el-input v-model="interviewTime" clearable></el-input> -->

					</el-form-item>
					<el-form-item label="面试地点：" prop="interviewAddress">
						<el-input v-model="queryInfoData.address" clearable></el-input>
					</el-form-item>
					<el-form-item label="面试通知书：" prop="interviewer">

						<el-upload class="avatar-uploader" :drag="true" v-if="!fileList.length" action=""
							:http-request="uploadImages">
							<div class="el-upload__text" >
								<img class="el-upload-img" src="@/assets/images/common/upload.png" />
								<span class="el-upload-span">点击或者拖拽上传</span>
							</div>
						</el-upload>
						<div v-else>
							<span class="fine-name">
								{{ fileList[0].url }}
							</span>
							<i class="iconfont icon-search" @click="openFile"></i>
							<i class="el-icon-delete" @click="deleteFile"></i>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="packge-btn-add">
				<el-button class="pageck-btn" @click="dialogShow = false">关闭</el-button>
				<el-button class="pageck-btn default" type="primary" @click="handleDialogClick">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { queryorderinterviewinfo, addorupdateorderinterviewinfo } from '@/api/order'
import alyoss from "@/utils/alyoss";

export default {
	data() {
		return {
			dialogShow: false,
			interviewAddress: '',
			interviewTime: '',
			fileList: [],
			queryInfoData: {
				address: '',
				url: '',
				id: '',
				orderId: '',
				time: '',
				orderApplicantId: '',
			},
		}
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		intervirewDialogData: {
			type: Object,
			default: () => { }
		}
	},
	watch: {
		show(val) {
			this.dialogShow = val
			if (val) {
				this.handleGetInterviewInfo()
			}
		},
	},
	methods: {
		closeDialog() {
			this.dialogShow = false
			this.fileList = []
			this.interviewAddress = ''
			this.interviewTime = ''
			this.$emit('closeDialog')
		},
		handleDialogClick() {
			console.log(this.interviewAddress, this.interviewTime)
			let data = { ...this.queryInfoData, url: this.fileList[0] ? this.fileList[0].url : '', }
			addorupdateorderinterviewinfo(data).then(res => {
				if (res.code == 1) {
					this.$message.success('操作成功')
					this.closeDialog()
				}
			})
		},
		handleGetInterviewInfo() {
			console.log(this.intervirewDialogData)
			queryorderinterviewinfo({ orderId: this.intervirewDialogData.id }).then(res => {
				console.log(res)
				if (res.code == 1) {
					this.queryInfoData = res.data
					if (this.queryInfoData.url) {
						this.fileList = [{ url: this.queryInfoData.url }]
					}
				}
			})
		},
		async uploadImages(file) {
			let res = await alyoss(file.file)
			console.log(res)
			this.fileList = [{ url: res }]
		},
		openFile() {
			window.open(this.fileList[0].url)
		},
		deleteFile() {
			this.$confirm('是否要删除面试通知书吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.fileList = []
				this.queryInfoData.url = ''
				let data = { ...this.queryInfoData, url: this.fileList[0] ? this.fileList[0].url : '', }
				addorupdateorderinterviewinfo(data).then(res => {
					if (res.code == 1) {
						this.$message.success('删除成功')
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
	},
}
</script>


<style lang="scss" scoped>
.interviewDialog {
	.avatar-uploader{
		width: 260px !important;
		v-deep .el-upload-dragger{
			width: 260px !important;
		}
	}
	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 22px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
		border: 1px dashed #d9d9d9;
		border-radius: 10px;
	}

	    .el-upload {
        width: 121px;
        height: 151px;
        background: #F2F8FF;
    }

    .el-upload-dragger {
        width: 100%;
        height: 100%;
        background: #F2F8FF;
        position: relative;
    }

    .el-upload-img {
        width: 47px;
        height: 47px;
        margin-top: 17px;
    }

    .el-upload-span {
        display: block;
        font-size: 12px;
        color: #3888E9;
        margin-top: 12px;
    }

    .el-upload__text {
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        flex: 1;
        height: 100%;

        // img {
        //     width: 47px;
        //     height: 47px;
        // }
    }

	.dialog-member-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: -10px;

		.dialog-member-name {
			font-size: 18px;
			font-weight: bold;
		}

		.dialog-close {
			width: 25px;
			height: 25px;
			background: #e0e0e0;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			.el-icon-close {
				color: #fff;
				font-size: 16px;
			}
		}
	}

	.quan-num-add {
		.quan-num-input {
			margin: 12px 0;
		}

		.quan-num-add-item {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.quan-num-add-title {
				font-size: 16px;
				margin-top: 12px;
			}

			.quan-num-right {
				margin-left: 16px;
				color: #3888e9;
				cursor: pointer;
			}
		}
	}

	.packge-btn-add {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: nowrap;

		.pageck-btn {
			width: 145px;
			margin: 0 16px;
		}
	}

	.upload-btn {
		width: 162px;
		height: 48px;
		background: #599fff;
		border-radius: 4px;
		border: 1px solid #5e9be1;
		color: #FFF;
		// margin-top: 32px;
		border: none;

		&:hover {
			background: #599fff;
			color: #FFF;
			border: none;
		}
	}


	.fine-name {
		color: #3888e9;
		margin-right: 5px;
	}

	i {
		cursor: pointer;
		display: inline-block;
	}

	.icon-search {
		color: #3888e9;
		margin-right: 10px;
	}

	.el-icon-delete {
		font-size: 18px;
		color: #ff5967;
	}
}
</style>

<style lang="scss"> 
.interviewDialog{
	.el-upload-dragger{
		width: 260px;
		height: 120px;
	}
}
</style>